export default __webpack_public_path__ + "static/media/transactIcon.d9c1a63e.svg";